export default {"src":"/_next/static/media/portfolio-catapult-header-icon-dark-theme.4aeeb01f.svg","height":58,"width":58};